import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const SubaccountsListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return <Common.Header title={t('subaccounts.subaccounts_title')}></Common.Header>;
};

export default translate()(SubaccountsListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/list/SubaccountsListHeader.js